<template>
  <pt-coupon-form class="pt-coupon-form__page" :isEdit="is_edit" :id="id"></pt-coupon-form>
</template>

<script>
import PtCouponForm from 'cps/mall-manage/pt-promotion-coupon/pt-coupon-form'
export default {
  name: 'pt-coupon-form__view',
  components: {
    'pt-coupon-form': PtCouponForm
  },
  props: {
    isEdit: {
      type: [Boolean, String],
      default: false
    },
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      is_edit: this.isEdit === 'true'
    }
  },
  created () {
    console.log(this.is_edit)
  }
}
</script>
